import Decimal from 'decimal.js';

import { applyDecimals, removeDecimals, toBN } from '@utils/formaters.utils';

import { PERCENT_DIVIDER } from '@constants/common/common.constants';

import {
  NormalizedStakingTokenData,
  PricesData,
  StakingToken,
} from '@app-types/vaults/priceRange.types';

export const PERCENT_DECIMALS = 18;

export const normalizePercent = (percent: bigint | string) =>
  removeDecimals(percent, PERCENT_DECIMALS).times(PERCENT_DIVIDER);

export const normalizePercentForContact = (percent: Decimal): bigint =>
  BigInt(
    applyDecimals(percent.abs(), PERCENT_DECIMALS)
      .div(PERCENT_DIVIDER)
      .toFixed(0),
  );

export const normalizeERC721 = (
  data: PricesData,
): NormalizedStakingTokenData => ({
  sqrtPriceX96ShiftPercentLow: data.sqrtPriceX96ShiftPercentLow,
  sqrtPriceX96ShiftPercentUp: data.sqrtPriceX96ShiftPercentUp,
  sqrtPriceX96DefaultShiftPercentLow: data.sqrtPriceX96DefaultShiftPercentLow,
  sqrtPriceX96DefaultShiftPercentUp: data.sqrtPriceX96DefaultShiftPercentUp,
  approxToRangeLimitLowPercent: BigInt(0),
  approxToRangeLimitUpPercent: BigInt(0),
});

export const normalizeToken = (
  data: StakingToken,
): NormalizedStakingTokenData => ({
  sqrtPriceX96ShiftPercentUp: data.deviationPercentUp,
  sqrtPriceX96ShiftPercentLow: data.deviationPercentLow,
  approxToRangeLimitUpPercent: data.approxToRangeLimitUpPercent,
  approxToRangeLimitLowPercent: data.approxToRangeLimitLowPercent,
  sqrtPriceX96DefaultShiftPercentUp: data.defaultDeviationPercentUp,
  sqrtPriceX96DefaultShiftPercentLow: data.defaultDeviationPercentLow,
});

export const getSqrtPrice = (sqrtPriceX96: string, percent: Decimal) => {
  const coefficient = toBN(1).plus(percent.div(2));

  return toBN(sqrtPriceX96).times(coefficient).toFixed();
};
